import React from 'react';
import { Card, Typography, Button } from 'antd';
import { useSelector } from 'react-redux';
import Meta from '../../components/Meta';
import { RootState } from '../../app/store';
import './SubscriptionScreen.less';
import { SubscriptionStatus } from '../../interfaces/subscription';
import { SUBSCRIPTION_LABELS } from '../../constants/subscription';

const { Title } = Typography;

const SubscriptionScreen: React.FC = () => {
  const { status, subscriptionInfo } = useSelector(
    (state: RootState) => state.subscription
  );
  const subscriptionData = subscriptionInfo?.subscription;

  const getStatusLabel = (status: SubscriptionStatus | undefined): string => {
    if (!status) return 'Inactive';
    switch (status) {
      case SubscriptionStatus.EXPIRED:
      case SubscriptionStatus.PAUSED:
      case SubscriptionStatus.PAST_DUE:
        return SUBSCRIPTION_LABELS[SubscriptionStatus.EXPIRED];
      default:
        return SUBSCRIPTION_LABELS[status];
    }
  };

  const getStatusClass = (status: SubscriptionStatus | undefined): string => {
    if (!status) return 'inactive';

    // Map status to CSS class names
    switch (status) {
      case SubscriptionStatus.ACTIVE:
        return 'active';
      case SubscriptionStatus.TRIALING:
        return 'trial';
      case SubscriptionStatus.INACTIVE:
      case SubscriptionStatus.INCOMPLETE:
      case SubscriptionStatus.EXPIRED:
      case SubscriptionStatus.PAUSED:
      case SubscriptionStatus.PAST_DUE:
      case SubscriptionStatus.UNKNOWN:
      case SubscriptionStatus.NOT_FOUND:
      case SubscriptionStatus.NOT_SUBSCRIBED:
      case SubscriptionStatus.INVALID:
        return status.toLowerCase();
      default:
        return 'unknown';
    }
  };

  return (
    <>
      <Meta name="Cirra AI - Subscription" />
      <div className="subscription-screen">
        <Title level={2}>Subscription</Title>
        <Card>
          <div className="subscription-info">
            <div className="info-item">
              <label>Status</label>
              <span className={`status-tag ${getStatusClass(status)}`}>
                {getStatusLabel(status)}
              </span>
            </div>
            {subscriptionData && (
              <>
                <div className="info-item">
                  <label>Plan</label>
                  <span>{'No Plan'}</span>
                </div>
                <div className="info-item">
                  <label>Billing Period</label>
                  <span>{'N/A'}</span>
                </div>
              </>
            )}
            <div className="subscription-actions">
              <Button type="primary">Manage Subscription</Button>
            </div>
          </div>
        </Card>
      </div>
    </>
  );
};

export default SubscriptionScreen;
